import { SidebarTrigger } from '@/components/ui/sidebar';

interface PortalPageHeaderProps {
  title: string;
  actions?: React.ReactNode;
}

export function PortalPageHeader({ title, actions }: PortalPageHeaderProps) {
  return (
    <header className="flex h-14 shrink-0 items-center gap-3 border-b border-white/[0.05] px-4 md:px-6">
      <SidebarTrigger className="-ml-1 h-7 w-7 text-white/38 hover:text-white/72 hover:bg-white/[0.05] transition-colors" />
      <div className="h-4 w-px bg-white/[0.08]" />
      <div className="flex flex-1 items-center">
        <h1 className="font-display text-lg font-medium text-foreground/90 tracking-tight">{title}</h1>
      </div>
      {actions && (
        <div className="flex items-center gap-2">
          {actions}
        </div>
      )}
    </header>
  );
}
